import React from "react";
import {Route} from "react-router-dom";
import {CREATE_EDIT_GROUP_ROUTE} from "../../utils/constants/RoutesConstants";
import CreateEditGroupContainer from "../../pages/maintenance/valueType/group/CreateEditGroupContainer";


const ValueTypeRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CREATE_EDIT_GROUP_ROUTE} component={CreateEditGroupContainer}/>
        </React.Fragment>
    );
};

export default ValueTypeRoutes;